<template>
  <v-container v-if="!gameStatus.pictureId">
    <v-row justify="center">
      <div v-for="contestant in gameStatus.contestants" :key="contestant.id">
        <v-col class="mb-1" cols="12">
          <v-card
              max-width="155"
              class="mx-auto my-1"
              elevation="7"
          >
            <v-img
                max-width="155"
                contain
                :src="avatar(contestant.avatar)"
            >
              <v-btn
                  color="red"
                  elevation="2"
                  fab
                  absolute
                  right
                  small
                  v-if="admin && !contestantId"
                  @click="contestantRemove(contestant)"
              >
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-img>

            <v-card-title justify="center" class="text-h4">
              {{ contestant.name }}
            </v-card-title>

            <v-divider class="mx-4"/>

            <v-card-text>
              <v-btn
                  color="green"
                  elevation="2"
                  fab
                  absolute
                  left
                  small
                  v-if="admin && !contestantId && gameStatus.inProgress"
                  @click="contestantDeductPoint(contestant)"
              >
                <v-icon>
                  mdi-minus
                </v-icon>
              </v-btn>

              <v-btn
                  color="green"
                  elevation="2"
                  fab
                  absolute
                  right
                  small
                  v-if="admin && !contestantId && gameStatus.inProgress"
                  @click="contestantAddPoint(contestant)"
              >
                <v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>

              <div class="text-h3 text-center">
                {{ contestant.score }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'QuizPanel',
  computed: mapGetters(['admin', 'contestantId', 'gameStatus']),
  methods: {
    ...mapActions(['removeContestant', 'addPoint', 'deductPoint']),
    avatar(avatarId) {
      return './avatar/' + avatarId + '.jpg';
    },
    contestantAddPoint(contestant) {
      this.addPoint(contestant.id);
    },
    contestantDeductPoint(contestant) {
      this.deductPoint(contestant.id);
    },
    contestantRemove(contestant) {
      this.removeContestant(contestant.id);
    },
  }
}
</script>
